// extracted by mini-css-extract-plugin
export default {"languageToggle":"LanguageToggle_languageToggle__kGEvc","languageButton":"LanguageToggle_languageButton__Yyh86","languageButtonActive":"LanguageToggle_languageButtonActive__POuFb"};